import { configureStore } from '@reduxjs/toolkit';
import dataReducer from './slices/dataSlice';


export const store = configureStore({
  reducer: {
    data: dataReducer
  }
})

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
